import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import HRDVApart from "../components/high-roof-dry-van-for-rent/HRDVApart";
import HRDVCommercialUses from "../components/high-roof-dry-van-for-rent/HRDVCommercialUses";
import HRDVFleetSpec from "../components/high-roof-dry-van-for-rent/HRDVFleetSpec";
import HRDVPricing from "../components/high-roof-dry-van-for-rent/HRDVPricing";
import HRDVCoverageAreas from "../components/high-roof-dry-van-for-rent/HRDVCoverageAreas";
import HRDVWhyChoose from "../components/high-roof-dry-van-for-rent/HRDVWhyChoose";
import HRDVFaq from "../components/high-roof-dry-van-for-rent/HRDVFaq";

import { highRoofDryVanForRentSections } from "../components/high-roof-dry-van-for-rent/highRoofDryVanForRentSections";
import "../components/high-roof-dry-van-for-rent/high-roof-dry-van-for-rent.css";
import "../components/home/home.css";

const HighRoofDryVanForRent = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "hrdv-hero":
        return (
          <ContactHero
            key={index}
            variant="high-roof-dry-van-for-rent"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "hrdv-apart":
        return (
          <HRDVApart
            key={index}
            title={section.title}
            description={section.description}
            methods={section.methods}
          />
        );

      case "hrdv-uses":
        return (
          <HRDVCommercialUses
            key={index}
            title={section.title}
            description={section.description}
            cargoTypes={section.cargoTypes}
          />
        );

      case "hrdv-fleet-spec":
        return (
          <HRDVFleetSpec
            key={index}
            title={section.title}
            description={section.description}
            image={section.image}
            imageAlt={section.imageAlt}
            specRows={section.specRows}
            note={section.note}
          />
        );

      case "hrdv-pricing":
        return (
          <HRDVPricing
            key={index}
            title={section.title}
            descriptionMain={section.descriptionMain}
            rateRows={section.rateRows}
            descriptionNote={section.descriptionNote}
          />
        );

      case "hrdv-coverage":
        return (
          <HRDVCoverageAreas
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
          />
        );

      case "hrdv-why-choose":
        return (
          <HRDVWhyChoose
            key={index}
            title={section.title}
            description={section.description}
            reasons={section.reasons}
          />
        );

      case "hrdv-faq":
        return (
          <HRDVFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>High Roof Dry Van for Rent in Dubai | Chiller Fleet Transport</title>
        <meta
          name="description"
          content="Chiller fleet transport offers high roof dry van for rent in Dubai & Sharjah for general cargo & packaged goods. With payload from 1.4 tons to 1.8 tons. Hire today."
        />
        <link rel="canonical" href="https://chillerfleet.com/high-roof-dry-van-for-rent" />
        <meta property="og:title" content="High Roof Dry Van for Rent in Dubai | Chiller Fleet Transport" />
        <meta
          property="og:description"
          content="Chiller fleet transport offers high roof dry van for rent in Dubai & Sharjah for general cargo & packaged goods. With payload from 1.4 tons to 1.8 tons. Hire today."
        />
        <meta property="og:url" content="https://chillerfleet.com/high-roof-dry-van-for-rent" />
        <meta name="twitter:title" content="High Roof Dry Van for Rent in Dubai | Chiller Fleet Transport" />
        <meta
          name="twitter:description"
          content="Chiller fleet transport offers high roof dry van for rent in Dubai & Sharjah for general cargo & packaged goods. With payload from 1.4 tons to 1.8 tons. Hire today."
        />
      </Helmet>

      {highRoofDryVanForRentSections.map(renderSection)}
    </>
  );
};

export default HighRoofDryVanForRent;
